import styled from 'styled-components';

const Column = styled.div`
  width: 300px;
  overflow: hidden;
  flex-shrink: 0;
`;

export default Column;
